module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SPIA.5736a3af.png";